import React, { useState } from 'react';
import "./header.scss";
import Navbar from "../../components/navbar/navbar";

function Header() {
  const [isOpen, setIsOpen] = useState(false);

  const scrollToSection = (id) => {
    const section = document.getElementById(id);
    if (section) {
      section.scrollIntoView({ behavior: 'smooth' });
      setIsOpen(false); // close menu after clicking a link
    }
  };
  return (
    <>
    <Navbar />
    <section
      className="hero"
      style={{ backgroundImage: `url("https://images.pexels.com/photos/5327915/pexels-photo-5327915.jpeg")` }}
    >
      <div className="hero__overlay">
        <h1>Daily Help United</h1>
        <p>Helping to Build a Healthy Community</p>
        <button onClick={() => scrollToSection('second')}className="hero__btn">Learn More</button>
      </div>
    </section>
    </>
  );
}

export default Header;
